import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import axios from "axios";
import { MenuSide } from "../../components/MenuSide";
import {
  urlInformacoesDisparos,
  urlApagarDisparos,
  tokenUsuario,
} from "../../utils/constants";
import dayjs from "dayjs";

export default function DetalheDisparos() {
  const [info, setInfo] = useState(null);

  const url = window.location.href;
  const urlBase = new URL(url);
  const id = urlBase.searchParams.get("id");
  const navigate = useNavigate();

  const informacoesContato = async () => {
    try {
      const response = await axios.post(urlInformacoesDisparos, {
        id: id,
        token: tokenUsuario,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  useEffect(() => {
    const run = async () => {
      const data = await informacoesContato();
      setInfo(data);
    };
    run();
    setInterval(() => {
      run();
    }, 60000);
  }, []);

  const excluirDisparo = async () => {
    try {
      const response = await axios.post(urlApagarDisparos, {
        id: urlBase.searchParams.get("id"),
        token: tokenUsuario,
      });
      if (response) {
        navigate({
          pathname: "/disparos",
        });
      }
    } catch (error) {
      return null;
    }
  };

  if (!info) {
    return <div>Carregando...</div>;
  }

  const { dados, grupos_envio, mensagens } = info;

  return (
    <div className="row">
      <div className="col-sm-2">
        <MenuSide />
      </div>
      <div className="col-sm-10">
        <br />
        <div className="card" style={{ marginRight: "1%" }}>
          <div className="card-header">
            <div className="row">
              <div
                className="col-sm-3"
                style={{ fontWeight: 700, fontSize: "25px" }}
              >
                Detalhes da mensagem
              </div>
              <div className="col-sm-9 text-end">
                <Button
                  color={"error"}
                  variant={"contained"}
                  onClick={() => {
                    excluirDisparo();
                  }}
                  style={{
                    width: 50,
                    height: 40,
                    borderRadius: "0.5rem",
                    marginTop: "4px",
                  }}
                >
                  <DeleteForeverOutlinedIcon style={{ color: "#ffffff" }} />
                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="card-body">
            {/* Informações principais da mensagem */}
            <h5>Mensagem: {dados.mensagem}</h5>
            <p>
              <b>Data:</b> {dayjs(dados.data).format("DD/MM/YYYY HH:mm")}
            </p>
            <p>
              <b>Template:</b> {dados.template}
            </p>

            <hr />

            {/* Listas de envio */}
            <h5>Listas de envio</h5>
            {grupos_envio.map((grupo) => {
              const totalContatos = grupo.contatos.length;
              const enviados = mensagens.filter(
                (m) => m.id_grupo === grupo.id_grupo && m.status === 1
              ).length;
              const pendentes = totalContatos - enviados;

              return (
                <div key={grupo.id_grupo} style={{ marginBottom: "20px" }}>
                  <h6>
                    Grupo: {grupo.nome}{" "}
                    <span style={{ fontSize: "14px", fontWeight: "normal" }}>
                      (Enviados: {enviados} / Pendentes: {pendentes})
                    </span>
                  </h6>
                  <ul>
                    {grupo.contatos.map((contato) => (
                      <li key={contato.id}>
                        {contato.nome} - {contato.numero}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}

            <hr />

            {/* Mensagens enviadas */}
            <h5>Mensagens enviadas</h5>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Contato</th>
                  <th>Número</th>
                  <th>Grupo</th>
                  <th>Status</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                {mensagens.map((msg) => {
                  const grupo = grupos_envio.find(
                    (g) => g.id_grupo === msg.id_grupo
                  );
                  return (
                    <tr key={msg.id + "-" + msg.data}>
                      <td>{msg.nome}</td>
                      <td>{msg.numero}</td>
                      <td>{grupo ? grupo.nome : msg.id_grupo}</td>
                      <td style={{ color: msg.status === 1 ? "green" : "red" }}>
                        {msg.status === 1 ? "Enviado" : "Não enviado"}
                      </td>
                      <td>{dayjs(msg.data).format("DD/MM/YYYY HH:mm")}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
